/** @format */
import { Author } from '@toucan/common/contentful/types';

export const getAuthorFullName = ({
    firstName,
    lastName,
}: Pick<Author, 'firstName' | 'lastName'>) =>
    [firstName, lastName].filter(Boolean).join(' ');

export const getAuthorPageSlug = (author: Pick<Author, 'linkedFrom'>) =>
    author.linkedFrom?.pageAuthorCollection?.items?.[0]?.urlSlug ?? null;
